import React from "react";
import styled from "styled-components";

const TabRow = styled.div`
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--nd-border);
  margin-bottom: 32px;
  flex-wrap: wrap;
`;

const TabBtn = styled.button`
  font-family: 'Space Mono', monospace;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: transparent;
  border: 0;
  border-bottom: 2px solid ${({ active }) => (active ? "var(--nd-text-display)" : "transparent")};
  color: ${({ active }) => (active ? "var(--nd-text-display)" : "var(--nd-text-disabled)")};
  padding: 12px 20px;
  cursor: pointer;
  outline: none;
  &:hover { color: var(--nd-text-secondary); }
`;

const TABS_LIST = [
  { id: "overview", label: "Overview" },
  { id: "juniors", label: "Juniors" },
];

const MentorTabs = ({ tab, onTabChange }) => (
  <TabRow role="tablist">
    {TABS_LIST.map((t) => (
      <TabBtn
        key={t.id}
        type="button"
        role="tab"
        aria-selected={tab === t.id}
        active={tab === t.id}
        onClick={() => onTabChange(t.id)}
      >
        {t.label}
      </TabBtn>
    ))}
  </TabRow>
);

export default MentorTabs;
